import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { IonicModule, LoadingController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { Analysis, BeerProfileRequest, BeerStat, SearchCharacteristicWithType, SearchType, AnalysisItem, LocalCharacteristic, Venue, SimilarBeerRequest, BaseFlavors} from "../../models/models";
import { AnalysisServiceProvider } from '../../providers/analysis-service/analysis-service';
import { LocationServiceProvider } from "../../providers/location-service/location-service";
import { UserDataProvider } from '../../providers/user-data/user-data';
import { BeerServiceProvider } from '../../providers/beer-service/beer-service';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { AnalysisHolderProvider } from '../../providers/analysis-holder/analysis-holder';
import { RefdataProvider } from '../../providers/refdata/refdata';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';
import { AppEventService } from '../../app/app-events';
import { SimilarBeersComponent } from '../similar-beers/similar-beers';
import { BeerSpiderComponent } from '../beer-spider/beer-spider';
import { BeerCcComponent } from '../beer-cc/beer-cc';
import { FlavorSliderAnalysisComponent } from '../flavor-slider/flavor-slider-analysis';
import { BeerHiveComponent } from '../beer-hive/beer-hive';
import { BeerIbaComponent } from '../beer-iba/beer-iba';
import { BeerAromasComponent } from '../beer-aromas/beer-aromas';
import { RatingBarComponent } from '../rating-bar/rating-bar';
import { WishlistButtonComponent } from '../wishlist-button/wishlist-button';
import { CommonModule } from '@angular/common';
import { MyNotesComponent } from '../my-notes/my-notes';
import { FormsModule } from '@angular/forms';

/*
 *. Base class for beer-analysis-my components
 */
export class BeerAnalysisMyComponent {

  /*
   *  attributes to manage the gui appearance
   */
  public loading: any = null; // will contain the "loading" gui element reference

  /*
   *  the model: beerID and analysis objects
   */
  theBeerID: string;
  private selectedVenue: Venue = null;

  /*
   *  other local attributes
   */
  // contains nbr of analyses per group (currently always 1 for group "brewer" and >=1 for group "beerhive")
  @Input()
  set beerID(bID: string) {
    this.theBeerID = bID;
    this.updateBeerID(bID);
  }
  get beerID() {
    return this.theBeerID;
  }

  constructor(
    protected toastController: ToastController,
    protected events: AppEventService,
    protected analysisService: AnalysisServiceProvider,
    protected bhutil: BhutilProvider,
    protected beerAnalysisHolder: AnalysisHolderProvider,
    protected translateService: TranslateService
  ) {
  }

  obsolete_addOrModifyAnalysis() {
    console.log("[beer-analysis-my].addOrModifyAnalysis() called");

    let myAnalysis: Analysis = this.beerAnalysisHolder.getMyAnalysis();
    
    if (this.beerAnalysisHolder.hasLoadedMyAnalysis()) {
      this.analysisService.updateAnalysis(myAnalysis, false).subscribe((resp: any) => {
      console.log("[beer-analysis-my].addOrModifyanalysis: RESPONSE - UPDATE ANALYSIS: " + this.bhutil.stringify(resp))
      let updatedAnalysisID = resp.analysisid;
      this.analysisService.setAnalysisId(updatedAnalysisID);

      // Update the analysis in the model
      this.beerAnalysisHolder.getMyAnalysis().id = resp.analysisid;
      let newLoadedAnalysis = this.beerAnalysisHolder.getMyAnalysis();
      this.beerAnalysisHolder.replaceMyAnalysis(newLoadedAnalysis);
//      this.beerAnalysisHolder.replaceMyAnalysis(resp);
      console.log("[beer-analysis-my].addOrModifyAnalysis(): updated analysis = ", this.beerAnalysisHolder.getMyAnalysis());

      // Show TOAST to informuser of successful update
      const toastProm = this.toastController.create({
        message: this.translateService.instant('BEERANALYSIS.YOUR_ANALYSIS_HAS_BEEN_UPDATED'),
        duration: 3000,
        position: 'bottom'
      });
      toastProm.then((toast) => { toast.present() });

      // Remove the save button
      this.events.publish("show:savebutton", false);

      console.log("beer-analysis-my] - update complete!")
      
    }, err => {
      console.error("[beer-analysis-my] ERROR - UPDATE ANALYSIS! " + err);
      console.log(err)
    });
    }
    else { // there was no former loaded my-analysis, so create a new
      this.analysisService.addAnalysis(myAnalysis).subscribe((resp: any) => {
      console.log("[beer-analysis-my] RESPONSE - ADD ANALYSIS: " + this.bhutil.stringify(resp));
      //debugger;
      // Update the analysis in the model
      this.beerAnalysisHolder.getMyAnalysis().id = resp.analysisid;
      let newLoadedAnalysis = this.beerAnalysisHolder.getMyAnalysis();
      this.beerAnalysisHolder.replaceMyAnalysis(newLoadedAnalysis);
//      this.beerAnalysisHolder.replaceMyAnalysis(resp);
      console.log("[beer-analysis-my].addOrModifyAnalysis(): updated analysis = ", this.beerAnalysisHolder.getMyAnalysis());
      //store the analysis ID!
      let addedAnalysisID = resp.analysisid;
      this.analysisService.setAnalysisId(addedAnalysisID);

      // TOAST
      const toastProm = this.toastController.create({
        message: this.translateService.instant('BEERANALYSIS.YOUR_ANALYSIS_HAS_BEEN_ADDED'),
        duration: 3000,
        position: 'bottom'
      });

      toastProm.then((toast) => { toast.present() });

      // Remove the save button
      this.events.publish("show:savebutton", false);
      }, err => {
        this.analysisService.setAnalysisId(null);//aanpassing Koen
        console.error("[beer-analysis-my] ERROR - ADD ANALYSIS! " + err);
        console.error(err)
      });
    }
  }

  dismissLoading() {
    if (this.loading != null) {
      this.loading.dismiss();
      this.loading = null;
    }
  }

  updateBeerID(bID: string) {
    console.log("updateBeerID() => " + bID);
    //debugger;
    this.theBeerID = bID;
    this.analysisService.setBeerId(bID);
  }

  public getRounded(input: number): number {
    let output = Math.round(input);
    return output;
  }
}
